/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The type of this slot.
 *
 * * *texture* is a simple image texture
 * * *object_3d* a mesh including materials etc.
 * * *complex* represents a set list of multiple slots, each having their own slot type
 * * *text* represents a text
 * * *attributes* is used to give an advertisement certain in-game settings and/or effect
 *
 * @export
 */
export const SlotType = {
    Texture: 'texture',
    Object3d: 'object_3d',
    Complex: 'complex',
    Text: 'text',
    Attributes: 'attributes'
};
export function instanceOfSlotType(value) {
    for (const key in SlotType) {
        if (Object.prototype.hasOwnProperty.call(SlotType, key)) {
            if (SlotType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function SlotTypeFromJSON(json) {
    return SlotTypeFromJSONTyped(json, false);
}
export function SlotTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SlotTypeToJSON(value) {
    return value;
}
export function SlotTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
